import { pageLoaderModel } from "@/shared/models/page-loader";
import { Vue } from "vue-property-decorator";

export class WorkInProgress extends Vue {
    mounted() {
        pageLoaderModel.toggle(false);
    }
}
